import script from "./InsideChatTool.vue?vue&type=script&setup=true&lang=js"
export * from "./InsideChatTool.vue?vue&type=script&setup=true&lang=js"

import "./InsideChatTool.vue?vue&type=style&index=0&id=3ee0840f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ee0840f"]])

export default __exports__